<div id="lm-header">
    <app-admin-header></app-admin-header>
    <app-header></app-header>
    <div class="container" *ngIf="userService.hasStudentExperience()">
        <app-student-app></app-student-app>
    </div>
</div>
<div>
    <iframe id="asset-content" scrolling="no" [src]="embedLocation"></iframe>
</div>
<app-footer></app-footer>
<app-simplified-footer></app-simplified-footer>
